import React, { useEffect, useState } from "react";
import {
  Typography,
  Button,
  CardContent,
  CardActions,
  Grid,
  Card,
  CardMedia,
  IconButton,
} from "@mui/material";
import {
  getPromotions,
  getPromotionsByVenueId,
  createPromotion,
  editPromotion,
  deletePromotion,
} from "../api";
import { Delete, Edit } from "@mui/icons-material";
import PromotionModal from "../components/PromotionModal";
import DeleteModal from "../components/DeleteModal";
import Loader from "../components/common/Loader";
import config from "../config";

export default function PromotionsPage() {
  const [state, setState] = useState({});

  const handleCreate = () => {
    setState((s) => ({
      ...s,
      open: true,
      promotion: undefined,
      handleConfirm: async (body) => {
        const promotion = await createPromotion(body);
        setState((s) => ({
          ...s,
          data: [promotion, ...s.data],
        }));
      },
    }));
  };

  const handleEdit = (item) => () => {
    setState((s) => ({
      ...s,
      open: true,
      promotion: item,
      handleConfirm: async (body) => {
        const promotion = await editPromotion(body);
        promotion.timestamp = Date.now();
        s.data.splice(
          s.data.indexOf(s.data.find((x) => x.id === promotion.id)),
          1,
          promotion
        );
      },
    }));
  };

  const handleClose = () => {
    setState((s) => ({
      ...s,
      open: false,
      promotion: undefined,
      handleConfirm: undefined,
    }));
  };

  const handleDelete = (item) => async () => {
    setState((s) => ({
      ...s,
      delete: true,
      deleteName: item.name,
      handleDeleteConfirm: async () => {
        await deletePromotion(item);
        setState((s) => ({
          ...s,
          data: [...s.data.filter((x) => x.id !== item.id)],
        }));
      },
    }));
  };

  const handleDeleteClose = () => {
    setState((s) => ({
      ...s,
      delete: false,
      deleteName: undefined,
      handleDeleteConfirm: undefined,
    }));
  };

  useEffect(() => {
    (async () => {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        const data =
          user.role === "venue"
            ? await getPromotionsByVenueId(user.venueId)
            : user.role === "admin"
            ? await getPromotions()
            : [];
        setState((s) => ({
          ...s,
          data,
          venueId: user.venueId,
          role: user.role,
        }));
      }
    })();
  }, []);

  return (
    <>
      <Grid
        container
        p={4}
        spacing={4}
        sx={{ maxWidth: "1600px", paddingTop: "80px" }}
        justifyContent={state.data?.length ? "left" : "center"}
      >
        {["venue", "admin"].includes(state.role) && (
          <Grid item xs={12}>
            <Button type="submit" onClick={handleCreate} variant="contained">
              Create Promotion
            </Button>
          </Grid>
        )}
        {state.data ? (
          state.data.map((item) => (
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
              key={item.id}
              sx={{ background: "transparent" }}
            >
              <Card variant="outlined" sx={{ backgroundColor: "#4b445b" }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={
                    item.timestamp
                      ? `${config.cdnUrl}/promotions/${item.id}?t=${item.timestamp}`
                      : `${config.cdnUrl}/promotions/${item.id}`
                  }
                  alt={item.name}
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    color="secondary"
                    sx={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      height: "64px",
                    }}
                  >
                    {item.name}
                  </Typography>
                </CardContent>
                <CardActions>
                  {["venue", "admin"].includes(state.role) && (
                    <IconButton
                      aria-label="edit"
                      onClick={handleEdit(item)}
                      color="secondary"
                      sx={{ marginLeft: "auto" }}
                    >
                      <Edit />
                    </IconButton>
                  )}
                  {["venue", "admin"].includes(state.role) && (
                    <IconButton
                      aria-label="delete"
                      onClick={handleDelete(item)}
                      color="secondary"
                    >
                      <Delete />
                    </IconButton>
                  )}
                </CardActions>
              </Card>
            </Grid>
          ))
        ) : (
          <Loader />
        )}
      </Grid>
      {state.open && (
        <PromotionModal
          venueId={state.venueId}
          promotion={state.promotion}
          handleConfirm={state.handleConfirm}
          handleClose={handleClose}
        />
      )}
      {state.delete && (
        <DeleteModal
          name={state.deleteName}
          handleConfirm={state.handleDeleteConfirm}
          handleClose={handleDeleteClose}
        />
      )}
    </>
  );
}
